export enum UnitOfWeightMeasureType {
  LBS = 'Lbs',
  KGS = 'Kgs',
}
